import { useState } from "react";
import UserDataModal from "./UserDataModal";
import { ReservationDataProps } from "@/types/type";

const ReservationData: React.FC<ReservationDataProps> = ({ user, refreshUserData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openUserDataModal = () => setIsModalOpen(true);
  const closeUserDataModal = () => setIsModalOpen(false);

  return (
    <div className="mt-2">
      <button
        onClick={openUserDataModal}
        className="text-blue-500 hover:underline text-sm"
      >
        Clique aqui
      </button>

      <UserDataModal
        isOpen={isModalOpen}
        onClose={closeUserDataModal}
        user={user}
        refreshUserData={refreshUserData}
      />
    </div>
  );
};

export default ReservationData;
